import LandingPageLayout from 'components/LandingPageLayout';
import TitleSectionOne from 'components/LandingPageTitleSection/TitleSectionOne';
import StaysLocation from 'components/LandingPageStaysLocation';
import React from 'react';
import ReservationForm from 'components/LandingPageReservationForm';
import Screening from 'components/landingPageScreening';
import Head from 'next/head';

const CommunicateWithSR = () => {
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Subscribe to a new way to manage properties</title>
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/communicate-with-sr" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Subscribe to a new way to manage properties" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="Save money on your rental property by using a one-stop solution to manage it."
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <meta
          name="description"
          content="Save money on your rental property by using a one-stop solution to manage it."
        />
        <meta
          property="og:description"
          content="Save money on your rental property by using a one-stop solution to manage it."
        />
      </Head>
      <LandingPageLayout>
        <StaysLocation
          img={'/static/images/landingPages/communicate-with-sr/msg.png'}
          title={'COMMUNICATE SEAMLESSLY'}
          description={
            <p className="  responsiveText pt-xl-4  pe-xl-1  " style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              Connect quickly and conveniently using the landlord's dashboard with SoulRooms. We provide centralized
              email communications linked to tenant profiles. Be it an ad-hoc notice, a maintenance trail, or general
              information everything you get where you exactly needed it.
            </p>
          }
          btnTitle={'Find out more'}
          href="#JotFormIFrame-212705784372257"
        />

        <Screening
          heading="THE ONE COMMUNICATION PLATFORM YOU NEED:"
          card1img="/static/images/landingPages/communicate-with-sr/communicationplateform1.png"
          card2img="/static/images/landingPages/communicate-with-sr/communicationplateform2.png"
          card3img="/static/images/landingPages/communicate-with-sr/communicationplateform3.png"
          card1Detail="All requests raised by tenants on the renter's portal straight to your dashboard in a well-defined trail to keep you organized. Yes, it auto sends update emails too!"
          card2Detail="Keeping track of all tenant communications is burdensome. One place to keep track of all 24-hour notices, ad-hoc information, and instructions for any or all tenants. "
          card3Detail="Built-in one-to-one chat and notification feature helps you communicate with individual tenants and keep records seamlessly. All communications are centralized and attached to associated tenant profiles."
        />

        <TitleSectionOne
          spacing={true}
          title="GET IN TOUCH TO START YOUR FREE TRIAL"
          btnTxt="Speak to a rep."
          target="_blank"
          hrefExt="https://calendly.com/srdemo/soulrooms-demo"
          bg="white"
        />
        {/* RESERVATION FORM  */}
        <ReservationForm heading="INTERESTED IN LEARNING MORE? DROP US A LINE.">
          <iframe
            id="JotFormIFrame-212705784372257"
            title="Your Web Design Client Questionnaire"
            onload="window.parent.scrollTo(0,0)"
            allowtransparency="true"
            allowfullscreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/212705784372257?isIframeEmbed=1"
            frameborder="0"
            style={{ minWidth: '100%', height: '640px', border: 'none' }}
            scrolling="no"></iframe>
        </ReservationForm>
      </LandingPageLayout>
    </>
  );
};

export default CommunicateWithSR;
